import { useLayoutEffect } from "react"
import { removeSplash } from "@/app/boot/splash"
import * as m from "@/paraglide/messages"
import luniLogoRu from "@/shared/assets/logo.webp"
import luniLogoEng from "@/shared/assets/logo-eng.webp"
import { getLocale } from "@/shared/lib/i18n"

function PhoneIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			viewBox="0 0 50 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				d="M15 12.6671V36.8337C15 39.1673 15 40.3335 15.4541 41.2248C15.8536 42.0088 16.4906 42.6468 17.2746 43.0463C18.165 43.5 19.3312 43.5 21.6602 43.5H29.1731C31.5021 43.5 32.6666 43.5 33.5571 43.0463C34.3411 42.6468 34.9802 42.0088 35.3796 41.2248C35.8333 40.3343 35.8333 39.1698 35.8333 36.8408V12.6602C35.8333 10.3312 35.8333 9.165 35.3796 8.27458C34.9802 7.49057 34.3411 6.85361 33.5571 6.45414C32.6658 6 31.5006 6 29.1671 6H21.6671C19.3335 6 18.1659 6 17.2746 6.45414C16.4906 6.85361 15.8536 7.49057 15.4541 8.27458C15 9.16588 15 10.3335 15 12.6671Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="25.5" cy="39.5" r="1.5" fill="currentColor" />
			<rect x="22" y="9" width="7" height="2" rx="1" fill="currentColor" />
		</svg>
	)
}

/** Renders text with every "Luni Monster" occurrence in bold, per the design. */
function withBoldBrand(text: string) {
	return text.split(/(Luni Monster)/g).map((part, i) =>
		part === "Luni Monster" ? (
			// biome-ignore lint/suspicious/noArrayIndexKey: static split, order is stable
			<span key={i} className="font-extrabold">
				{part}
			</span>
		) : (
			part
		),
	)
}

/**
 * This screen renders before the router and the server-side `app_language`.
 * `getLocale()` gives the locale saved in localStorage (the last synced
 * `app_language`), else the browser language.
 */
export function DesktopBlockScreen() {
	const locale = getLocale()
	// Only the Russian logo is localised; every other locale takes the English one.
	const logo = locale === "ru" ? luniLogoRu : luniLogoEng

	useLayoutEffect(() => {
		removeSplash()
	}, [])

	return (
		<div className="fixed inset-0 flex flex-col items-center justify-center gap-12 bg-white px-8">
			<PhoneIcon className="size-12.5 text-gray-800" />
			<div className="max-w-70 text-center">
				<p className="text-lg leading-snug whitespace-pre-line text-gray-800">
					{withBoldBrand(m.desktopBlockMessage())}
				</p>
				<p className="mt-6 text-sm whitespace-pre-line text-gray-600">
					{m.desktopBlockSubtitle()}
				</p>
				<p className="mt-5 text-sm whitespace-pre-line text-gray-600">
					{withBoldBrand(m.desktopBlockDownload())}
				</p>
			</div>
			<img src={logo} alt="Luni Monster" className="h-8 w-auto" />
		</div>
	)
}
